"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.backgroundUploaded = backgroundUploaded;
exports.backgroundUploadedOnStage = backgroundUploadedOnStage;
exports.contentUploaded = contentUploaded;
exports.defaultValidationErrorHandler = exports["default"] = void 0;
exports.hostAddedMediaToStage = hostAddedMediaToStage;
exports.hostAddedScreenshareToStage = hostAddedScreenshareToStage;
exports.hostAddedSpeakerToStage = hostAddedSpeakerToStage;
exports.hostChangesStageLayout = hostChangesStageLayout;
exports.hostEnters = hostEnters;
exports.hostSendsSpeakerChatMessage = hostSendsSpeakerChatMessage;
exports.hostSpotlightsSourceFromSourceTile = hostSpotlightsSourceFromSourceTile;
exports.hostSpotlightsSourceFromStage = hostSpotlightsSourceFromStage;
exports.hostTogglesSpeakerCameraFromSourceTile = hostTogglesSpeakerCameraFromSourceTile;
exports.hostTogglesSpeakerMicFromSourceTile = hostTogglesSpeakerMicFromSourceTile;
exports.loadPresenterAvModal = loadPresenterAvModal;
exports.meetingAsHost = meetingAsHost;
exports.nameCardsToggled = nameCardsToggled;
exports.presenterAddedToChimeMeeting = presenterAddedToChimeMeeting;
exports.presenterProgramStatusUpdate = presenterProgramStatusUpdate;
exports.recordingStartWorkflow = recordingStartWorkflow;
exports.recordingStopWorkflow = recordingStopWorkflow;
exports.setRudderTyperOptions = setRudderTyperOptions;
exports.speakerEnters = speakerEnters;
exports.stockContentUsed = stockContentUsed;
exports.streamStartLifecycle = streamStartLifecycle;
exports.streamStartWorkflow = streamStartWorkflow;
exports.streamStopLifecycle = streamStopLifecycle;
exports.streamStopWorkflow = streamStopWorkflow;
exports.totalScreenShare = totalScreenShare;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * This client was automatically generated. ** Do Not Edit **
 */
/**
 * The default handler that is fired if none is supplied with setRudderTyperOptions.
 * This handler will log a warning message to the console.
 */
var defaultValidationErrorHandler = exports.defaultValidationErrorHandler = function defaultValidationErrorHandler(message, violations) {
  var msg = JSON.stringify({
    type: 'Tracking Plan JSON Schema Validation Error',
    description: "You made an analytics call (".concat(message.event, ") using the auto generate client that doesn't match the ") + 'Tracking Plan spec.',
    errors: violations
  }, undefined, 2);
  console.warn(msg);
};
var analytics = function analytics() {
  return window.analytics;
};
/**
 * Updates the run-time configuration of this RudderTyper client.
 *
 * @param {RudderTyperOptions} options - the options to upsert
 *
 * @typedef {Object} RudderTyperOptions
 * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
 * 		calls are forwarded on to. Defaults to window.analytics.
 * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
 * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
 * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
 * 		will be logged to stderr.
 */
function setRudderTyperOptions(options) {
  analytics = options.analytics ? function () {
    return options.analytics || window.analytics;
  } : analytics;
}
/**
 * Helper to attach metadata on RudderTyper to outbound requests.
 * This is used for attribution and debugging by the RudderStack team.
 */
function withRudderTyperContext() {
  var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return _objectSpread(_objectSpread({}, message), {}, {
    context: _objectSpread(_objectSpread({}, message.context || {}), {}, {
      ruddertyper: {
        sdk: 'analytics.js',
        language: 'javascript',
        rudderTyperVersion: '',
        trackingPlanId: 'tp_2VcMepdGsODn30mzqfuBdd60Wrw',
        trackingPlanVersion: '2'
      }
    })
  });
}
/**
 * @typedef BackgroundUploaded
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef BackgroundUploadedOnStage
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef ContentUploaded
 * @property {string} [title] - The title of the uploaded file
 * @property {string} [fileType] - The file type
 * @property {string} [extension] - The file extension
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostAddedMediaToStage
 * @property {string} [title] - the title of the added media
 * @property {string} [fileType] - the type of media added, could be videoFile, imageFile, audioFile, pdfFile, media
 * @property {string} [eventDocId] - the eventDocId of the added media
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostAddedScreenshareToStage
 * @property {string} [title] - the title of the added screenshare source
 * @property {string} [screenshareId] - the id of the screenshare source. This which will match the speakerId with "#content" added at the end
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostAddedSpeakerToStage
 * @property {string} [speakerId] - the id of the added speaker
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostChangesStageLayout
 * @property {string} [layout] - the name of the layout that was changed to.
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostEnters
 * @property {string} [attendeeId] - this is the attendee id
 * @property {string} [presenterName] - this is the attendee name
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostSendsSpeakerChatMessage
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostSpotlightsSourceFromSourceTile
 * @property {string} [sourceId] - Id of the spotlighted source
 * @property {string} [sourceType] - Type of the spotlighted source
 * @property {string} [sourceTitle] - Title of the spotlighted source
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostSpotlightsSourceFromStage
 * @property {string} [sourceId] - Id of the spotlighted source
 * @property {string} [sourceType] - Type of the spotlighted source
 * @property {string} [sourceTitle] - Title of the spotlighted source
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef RecordingStartWorkflow
 * @property {any[]} [recordingIds] - The recording IDs
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef StreamStartWorkflow
 * @property {any[]} [activeStreamsIds] - The stream IDs
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef RecordingStopWorkflow
 * @property {string} [recordingId] - The recording ID
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef StreamStopWorkflow
 * @property {any[]} [activeStreamsIds] - The stream IDs
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef HostTogglesSpeakerCameraFromSourceTile
 * @property {string} [toggleState] - Speaker camera toggle ON/OFF state
 * @property {string} [speakerId] - Id of speaker whose camera is toggled
 * @property {string} [speakerTitle] - Title of speaker whose camera is toggled
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef HostTogglesSpeakerMicFromSourceTile
 * @property {string} [toggleState] - Speaker mic toggle ON/OFF state
 * @property {string} [speakerId] - Id of speaker whose mic is toggled
 * @property {string} [speakerTitle] - Title of speaker whose mic is toggled
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef LoadPresenterAvModal
 * @property {string} [broadcastId] - this is the broadcast id
 * @property {string} [presenterName] - presenter/speaker name
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef MeetingAsHost
 * @property {string} attendeeId - this is the attendee id
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef NameCardsToggled
 * @property {string} [toggleState] - Name cards toggle ON/OFF state
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef PresenterAddedToChimeMeeting
 * @property {string} [presenterName] - this is the presenter name
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef PresenterProgramStatusUpdate
 * @property {string} [presenterId] - the id of the added presenter
 * @property {string} [operation] - the operation to hide or add presenter to stage
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef SpeakerEnters
 * @property {string} [speakerCamera] - The camera selected by the speaker
 * @property {string} [speakerMicrophone] - The microphone selected by the speaker
 * @property {string} [speakerName] - The name of speaker entering studio session
 * @property {string} [speakerTitle] - The title of speaker entering studio session
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef StockContentUsed
 * @property {string} [templateName] - The name of stock template selected by host
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * @typedef StreamStartLifecycle
 * @property {string} [streamId] - The stream ID
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef StreamStopLifecycle
 * @property {string} [streamId] - The stream ID
 * @property {string} [pathName] - this is the pathname of the application
 * @property {string} [url] - this is the url of the application
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 * @property {string} [incomplete_measure] - In case this action needs to be tracked as incomplete, this property value should have the reason why it could not be measured/completed
 */
/**
 * @typedef TotalScreenShare
 * @property {string} [screenShareCount] - Screen share count
 * @property {string} [message] - message about the screen share
 * @property {any[]} [presenterScreenShareNames] - name of presenter's who shares screen
 * @property {string} appVersion - The current application version. Value should be grabbed from your app's package.json file
 * @property {string} product - Identifier to reference the product that is sending the action to the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} businessUnit - Identifier to reference the business unit in the downstream tools. Visit the Product Breakdown wiki to learn more
 * @property {string} component - Unique identifier to reference the application that is sending the action to the downstream tools
 * @property {string} environmentName - Identifier to reference the environment where the action was sent from
 * @property {string} [userId] - Identifier to reference the user that executed the action
 * @property {string} userGroup - Identifier to reference the group a user belongs to
 * @property {string} persona - Identifier to represent the user's characteristics
 * @property {boolean} isCVIIUser - Identifier to reference if an action was executed by a user logging in from cvii or a user loggin from within the application
 * @property {string} trackingPlanName - Identifier to reference the name of the tracking plan this action is associated with
 * @property {string} [utmCampaign] - The campaign name the user belongs to. This property is automatically captured by the framework and set as a base property as long as the utm_campaign param is in the current url as part of the query string
 * @property {string} [utmContent] - Used to identify the exact element on an ad or promotion that was clicked. This property is automatically captured by the framework and set as a base property as long as the utm_content param is in the current url as part of the query string
 * @property {string} [utmMedium] - Defines which medium the visitor used to find our website. This property is automatically captured by the framework and set as a base property as long as the utm_medium param is in the current url as part of the query string
 * @property {string} [utmSource] - The source of the traffic, that is, from which site, advertiser, or publication the user came from. This property is automatically captured by the framework and set as a base property as long as the utm_source param is in the current url as part of the query string
 * @property {string} [utmTerm] - Used to manually identify paid keywords targeted by your campaign. This property is automatically captured by the framework and set as a base property as long as the utm_term param is in the current url as part of the query string
 * @property {string} [error] - In case this action ends in an error, this property value should have the reason why it failed
 * @property {string} [expected_error] - In case this action needs to be tracked as an expected error, this property value should have the expected error message
 */
/**
 * this action tracks the users who upload a custom background in order to understand how many users are creating custom backgrounds
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMepZgdlXMWD3ORK2EJCYaAKd
 * name          : studio background uploaded
 * downstreamName: background uploaded
 * owner         : vikings
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the user uploads a background image locally and clicks the save button in the upload background modal
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {BackgroundUploaded} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function backgroundUploaded(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'background uploaded';
  if (a) {
    a.track('studio background uploaded', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in uploading a background image on the stage
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeo3UKYzw6h6uQbxEOi7hPsD
 * name          : studio background uploaded on stage
 * downstreamName: background uploaded on stage
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user clicks the save button in the upload background modal and ends when the image uploads on the stage
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {BackgroundUploadedOnStage} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function backgroundUploadedOnStage(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'background uploaded on stage';
  if (a) {
    a.track('studio background uploaded on stage', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who upload content in order to determine content is being successfully uploaded
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeldCvGmrRAHwROauiH92e54
 * name          : studio studio content uploaded
 * downstreamName: content uploaded
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the user uploads content and clicks the upload button in the add media modal
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {ContentUploaded} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function contentUploaded(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'content uploaded';
  if (a) {
    a.track('studio studio content uploaded', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who are adding media to stage in order to better understand the quantity and how often this is occurring throughout a webinar
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMenZtxsXyMKHU3LOq1HHyi5j
 * name          : studio host added media to stage
 * downstreamName: host added media to stage
 * owner         : vikings
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a media source and clicks the show button
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostAddedMediaToStage} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostAddedMediaToStage(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host added media to stage';
  if (a) {
    a.track('studio host added media to stage', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who are adding screenshares to stage in order to better understand the quantity and how often this is occurring throughout a webinar
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeoDxFrXC8qonY097NqfJGmz
 * name          : studio host added screenshare to stage
 * downstreamName: host added screenshare to stage
 * owner         : vikings
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a screenshare source and clicks the "show" button
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostAddedScreenshareToStage} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostAddedScreenshareToStage(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host added screenshare to stage';
  if (a) {
    a.track('studio host added screenshare to stage', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who adds a speaker, themselves, or another host to stage in order to better understand the quantity and how often this is occurring
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMemdrgdWULq4JX0wLU3TbIZe
 * name          : studio host added speaker to stage
 * downstreamName: host added speaker to stage
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a speaker source and clicks the show button
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostAddedSpeakerToStage} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostAddedSpeakerToStage(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host added speaker to stage';
  if (a) {
    a.track('studio host added speaker to stage', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who changes the stage layout to any of the available layouts in order to better understand which layouts are being used
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMelu6xKclwhpqIOvoKk02FI0
 * name          : studio host changes stage layout
 * downstreamName: host changes stage layout
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host clicks any of the layout on the layout bar
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostChangesStageLayout} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostChangesStageLayout(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host changes stage layout';
  if (a) {
    a.track('studio host changes stage layout', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who enters a studio session in order to determine how many users are joining as hosts
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMekb4RhLhaEGChHWof1UI9mO
 * name          : studio host enters studio
 * downstreamName: host enters
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host clicks the enter the studio button on the join modal
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostEnters} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostEnters(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host enters';
  if (a) {
    a.track('studio host enters studio', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who sends speakers messages using chat in order to better understand chat usage
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMej5Nc3E0GSEoI6M8jzJVPRA
 * name          : studio host sends speaker chat message
 * downstreamName: host sends speaker chat message
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host clicks enter or return key in the message input field in speaker chat
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostSendsSpeakerChatMessage} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostSendsSpeakerChatMessage(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host sends speaker chat message';
  if (a) {
    a.track('studio host sends speaker chat message', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who spotlight a source from the source tile in order to better understand which spotlight option is being used more or less
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMelWz09Eh8abbXrCYhxxxsXq
 * name          : studio host spotlights source from source tile
 * downstreamName: host spotlights source from source tile
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a source on the source tile and clicks the spotlight button
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostSpotlightsSourceFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostSpotlightsSourceFromSourceTile(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host spotlights source from source tile';
  if (a) {
    a.track('studio host spotlights source from source tile', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who spotlight a source from stage in order to better understand which spotlight option is being used more or less
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMepTguwPrOo84AM6tTSsCqQv
 * name          : studio host spotlights source from stage
 * downstreamName: host spotlights source from stage
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a source on stage and clicks the spotlight button
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostSpotlightsSourceFromStage} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostSpotlightsSourceFromStage(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host spotlights source from stage';
  if (a) {
    a.track('studio host spotlights source from stage', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in starting the recording
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMenH1dghR9FKWY5gh2TFmaKK
 * name          : studio recording start workflow
 * downstreamName: recording start workflow
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user click on the start/startAll record button and ends when the recording is started or failed in starting
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {RecordingStartWorkflow} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function recordingStartWorkflow(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'recording start workflow';
  if (a) {
    a.track('studio recording start workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in starting the stream
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMejw8oZtFxIDKeBdzhJ35I3D
 * name          : studio stream start workflow
 * downstreamName: stream start workflow
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user click on the start stream button and ends when the stream is started or failed in starting
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {StreamStartWorkflow} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function streamStartWorkflow(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'stream start workflow';
  if (a) {
    a.track('studio stream start workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in stopping the recording
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMenH1dghR9FKWY5gh2TFmaKK
 * name          : studio recording stop workflow
 * downstreamName: recording stop workflow
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user click on the stop/stopAll record button and ends when the recording is stopped or failed in stopping
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {RecordingStopWorkflow} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function recordingStopWorkflow(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'recording stop workflow';
  if (a) {
    a.track('studio recording stop workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in stopping the stream
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMepJKnRts2ekuGYkeXRFmJiT
 * name          : studio stream stop workflow
 * downstreamName: stream stop workflow
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user click on the stop stream button and ends when the stream is stopped or failed in stopping
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {StreamStopWorkflow} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function streamStopWorkflow(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'stream stop workflow';
  if (a) {
    a.track('studio stream stop workflow', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who toggle camera for a speaker source from the source tile in order to better understand how how cameras are being turned on
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMelyGkpwBBbCk3oHu538sZ4C
 * name          : studio host toggles speaker camera from source tile
 * downstreamName: host toggles speaker camera from source tile
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a source on the source tile and clicks camera icon
 * destinations  : Datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostTogglesSpeakerCameraFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostTogglesSpeakerCameraFromSourceTile(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host toggles speaker camera from source tile';
  if (a) {
    a.track('studio host toggles speaker camera from source tile', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who toggles speaker source mic from the source tile in order to better understand how often mics are being toggled
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeq6sM9IinTASO0d8uYFaTa9
 * name          : studio host toggles speaker mic from source tile
 * downstreamName: host toggles speaker mic from source tile
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the host hovers over a source on the source tile and toggles mic
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {HostTogglesSpeakerMicFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function hostTogglesSpeakerMicFromSourceTile(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'host toggles speaker mic from source tile';
  if (a) {
    a.track('studio host toggles speaker mic from source tile', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in entering presenter name to display presenter av modal
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeqNEvLvS7ftS2vwD0Iz54Sc
 * name          : studio load presenter av modal
 * downstreamName: load presenter av modal
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when clicking on ask to enter button and ends when presenter av modal gets displayed
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {LoadPresenterAvModal} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function loadPresenterAvModal(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'load presenter av modal';
  if (a) {
    a.track('studio load presenter av modal', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in director lite application to get loaded till the chime meeting creation
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeny4usepwA0m0rUkS7YjjNP
 * name          : studio meeting as host
 * downstreamName: meeting as host
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the application started for chime meeting creation and ends when the chime meeting got created
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {MeetingAsHost} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function meetingAsHost(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'meeting as host';
  if (a) {
    a.track('studio meeting as host', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who toggle name cards in order to better understand if and when name cards are used
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMelpdJu18a9oPsUKAdsTMMtT
 * name          : studio name cards toggled
 * downstreamName: name cards toggled
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the user toggles the name card
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {NameCardsToggled} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function nameCardsToggled(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'name cards toggled';
  if (a) {
    a.track('studio name cards toggled', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in presenter getting added to a chime meeting.
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMekRHdCvCEm0GKbgq1JDMFpR
 * name          : studio presenter added to chime meeting
 * downstreamName: presenter added to chime meeting
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when host accepts the knock request and ends when presenter is added to chime meeting successfully
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {PresenterAddedToChimeMeeting} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function presenterAddedToChimeMeeting(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'presenter added to chime meeting';
  if (a) {
    a.track('studio presenter added to chime meeting', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in adding/removing the presenter from program
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeqLKQ6UswDojxzDE0hqZ2Je
 * name          : studio presenter program status update
 * downstreamName: presenter program status update
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the host hovers over a presenter source and clicks the show/hide button and ends when presenter is visible/removed from program
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {PresenterProgramStatusUpdate} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function presenterProgramStatusUpdate(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'presenter program status update';
  if (a) {
    a.track('studio presenter program status update', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who enter the studio after knock is approved in order to understand speaker experience joining the studio
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMek6vGle76DdjtYLbpUWbh0D
 * name          : studio speaker enters studio
 * downstreamName: speaker enters
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the user clicks the enter the studio button on the final join modal
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {SpeakerEnters} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function speakerEnters(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'speaker enters';
  if (a) {
    a.track('studio speaker enters studio', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who use our stock content for their webinar in order to see how often they are used
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMejtXyCXQZMPvJsQLGazMfSS
 * name          : studio stock content used
 * downstreamName: stock content used
 * owner         : quickfixjedis
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the user selects stock content and clicks save button
 * destinations  : Datadog,Mixpanel,Intercom,Snowflake
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {StockContentUsed} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function stockContentUsed(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'stock content used';
  if (a) {
    a.track('studio stock content used', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in starting the stream
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            :
 * name          : studio stream start lifecycle
 * downstreamName: stream start lifecycle
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       :
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user click on the start/startAll stream button and ends when the streaming is started or failed in starting
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {StreamStartLifecycle} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function streamStartLifecycle(props, options, callback) {
  var a = analytics();
  var version = '';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'stream start lifecycle';
  if (a) {
    a.track('studio stream start lifecycle', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action measures the time taken in stopping the stream
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            :
 * name          : studio stream stop lifecycle
 * downstreamName: stream stop lifecycle
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       :
 * type          : measure
 * multiStep     :  no
 * trigger       : the measurement starts when the user click on the stop/stopAll stream button and ends when the streaming is stopped or failed in stopping
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {StreamStopLifecycle} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function streamStopLifecycle(props, options, callback) {
  var a = analytics();
  var version = '';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'stream stop lifecycle';
  if (a) {
    a.track('studio stream stop lifecycle', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
/**
 * this action tracks the users who as presenter share screen in order to determine screen share total is working fine
 *
 * Action Definition:
 * ------------------------------------------------------
 * status        : active
 * id            : ev_2VcMeo6kDKYM3TAQr5HBGjykkKw
 * name          : studio total screen share
 * downstreamName: total screen share
 * owner         : qwerty
 * externalName  :
 * release       : v2.0
 * version       : 1-0-0
 * type          : track
 * multiStep     :  no
 * trigger       : this action is triggered when the user shares the screen and see the total count of share screen
 * destinations  : datadog,Mixpanel,Snowflake,Intercom
 * sdk           : analytics.js
 * ------------------------------------------------------
 *
 * @param {TotalScreenShare} [props] - The analytics properties that will be sent to RudderStack.
 * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
 */
function totalScreenShare(props, options, callback) {
  var a = analytics();
  var version = '1-0-0';
  // This is passed as a property so via a transformation we use the downstreamName instead
  var downstreamName = 'total screen share';
  if (a) {
    a.track('studio total screen share', _objectSpread(_objectSpread({}, props), {}, {
      version: version,
      downstreamName: downstreamName
    }), withRudderTyperContext(options), callback);
  }
}
var clientAPI = {
  /**
   * Updates the run-time configuration of this RudderTyper client.
   *
   * @param {RudderTyperOptions} options - the options to upsert
   *
   * @typedef {Object} RudderTyperOptions
   * @property {Rudder.AnalyticsJS} [analytics] - Underlying analytics instance where analytics
   * 		calls are forwarded on to. Defaults to window.analytics.
   * @property {Function} [onViolation] - Handler fired when if an event does not match its spec. This handler does not fire in
   * 		production mode, because it requires inlining the full JSON Schema spec for each event in your Tracking Plan. By default,
   * 		it will throw errors if NODE_ENV="test" so that tests will fail if a message does not match the spec. Otherwise, errors
   * 		will be logged to stderr.
   */
  setRudderTyperOptions: setRudderTyperOptions,
  /**
   * this action tracks the users who upload a custom background in order to understand how many users are creating custom backgrounds
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepZgdlXMWD3ORK2EJCYaAKd
   * name          : studio background uploaded
   * downstreamName: background uploaded
   * owner         : vikings
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user uploads a background image locally and clicks the save button in the upload background modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {BackgroundUploaded} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  backgroundUploaded: backgroundUploaded,
  /**
   * this action measures the time taken in uploading a background image on the stage
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeo3UKYzw6h6uQbxEOi7hPsD
   * name          : studio background uploaded on stage
   * downstreamName: background uploaded on stage
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user clicks the save button in the upload background modal and ends when the image uploads on the stage
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {BackgroundUploadedOnStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  backgroundUploadedOnStage: backgroundUploadedOnStage,
  /**
   * this action tracks the users who upload content in order to determine content is being successfully uploaded
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeldCvGmrRAHwROauiH92e54
   * name          : studio studio content uploaded
   * downstreamName: content uploaded
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user uploads content and clicks the upload button in the add media modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {ContentUploaded} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  contentUploaded: contentUploaded,
  /**
   * this action tracks the users who are adding media to stage in order to better understand the quantity and how often this is occurring throughout a webinar
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMenZtxsXyMKHU3LOq1HHyi5j
   * name          : studio host added media to stage
   * downstreamName: host added media to stage
   * owner         : vikings
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a media source and clicks the show button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostAddedMediaToStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostAddedMediaToStage: hostAddedMediaToStage,
  /**
   * this action tracks the users who are adding screenshares to stage in order to better understand the quantity and how often this is occurring throughout a webinar
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeoDxFrXC8qonY097NqfJGmz
   * name          : studio host added screenshare to stage
   * downstreamName: host added screenshare to stage
   * owner         : vikings
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a screenshare source and clicks the "show" button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostAddedScreenshareToStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostAddedScreenshareToStage: hostAddedScreenshareToStage,
  /**
   * this action tracks the users who adds a speaker, themselves, or another host to stage in order to better understand the quantity and how often this is occurring
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMemdrgdWULq4JX0wLU3TbIZe
   * name          : studio host added speaker to stage
   * downstreamName: host added speaker to stage
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a speaker source and clicks the show button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostAddedSpeakerToStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostAddedSpeakerToStage: hostAddedSpeakerToStage,
  /**
   * this action tracks the users who changes the stage layout to any of the available layouts in order to better understand which layouts are being used
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelu6xKclwhpqIOvoKk02FI0
   * name          : studio host changes stage layout
   * downstreamName: host changes stage layout
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host clicks any of the layout on the layout bar
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostChangesStageLayout} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostChangesStageLayout: hostChangesStageLayout,
  /**
   * this action tracks the users who enters a studio session in order to determine how many users are joining as hosts
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMekb4RhLhaEGChHWof1UI9mO
   * name          : studio host enters studio
   * downstreamName: host enters
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host clicks the enter the studio button on the join modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostEnters} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostEnters: hostEnters,
  /**
   * this action tracks the users who sends speakers messages using chat in order to better understand chat usage
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMej5Nc3E0GSEoI6M8jzJVPRA
   * name          : studio host sends speaker chat message
   * downstreamName: host sends speaker chat message
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host clicks enter or return key in the message input field in speaker chat
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSendsSpeakerChatMessage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostSendsSpeakerChatMessage: hostSendsSpeakerChatMessage,
  /**
   * this action tracks the users who spotlight a source from the source tile in order to better understand which spotlight option is being used more or less
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelWz09Eh8abbXrCYhxxxsXq
   * name          : studio host spotlights source from source tile
   * downstreamName: host spotlights source from source tile
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on the source tile and clicks the spotlight button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSpotlightsSourceFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostSpotlightsSourceFromSourceTile: hostSpotlightsSourceFromSourceTile,
  /**
   * this action tracks the users who spotlight a source from stage in order to better understand which spotlight option is being used more or less
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepTguwPrOo84AM6tTSsCqQv
   * name          : studio host spotlights source from stage
   * downstreamName: host spotlights source from stage
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on stage and clicks the spotlight button
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostSpotlightsSourceFromStage} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostSpotlightsSourceFromStage: hostSpotlightsSourceFromStage,
  /**
   * this action measures the time taken in starting the recording
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMenH1dghR9FKWY5gh2TFmaKK
   * name          : studio recording start workflow
   * downstreamName: recording start workflow
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the start/startAll record button and ends when the recording is started or failed in starting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {RecordingStartWorkflow} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  recordingStartWorkflow: recordingStartWorkflow,
  /**
   * this action measures the time taken in starting the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMejw8oZtFxIDKeBdzhJ35I3D
   * name          : studio stream start workflow
   * downstreamName: stream start workflow
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the start stream button and ends when the stream is started or failed in starting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStartWorkflow} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStartWorkflow: streamStartWorkflow,
  /**
   * this action measures the time taken in stopping the recording
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMenH1dghR9FKWY5gh2TFmaKK
   * name          : studio recording stop workflow
   * downstreamName: recording stop workflow
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the stop/stopAll record button and ends when the recording is stopped or failed in stopping
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {RecordingStopWorkflow} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  recordingStopWorkflow: recordingStopWorkflow,
  /**
   * this action measures the time taken in stopping the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMepJKnRts2ekuGYkeXRFmJiT
   * name          : studio stream stop workflow
   * downstreamName: stream stop workflow
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the stop stream button and ends when the stream is stopped or failed in stopping
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStopWorkflow} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStopWorkflow: streamStopWorkflow,
  /**
   * this action tracks the users who toggle camera for a speaker source from the source tile in order to better understand how how cameras are being turned on
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelyGkpwBBbCk3oHu538sZ4C
   * name          : studio host toggles speaker camera from source tile
   * downstreamName: host toggles speaker camera from source tile
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on the source tile and clicks camera icon
   * destinations  : Datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostTogglesSpeakerCameraFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostTogglesSpeakerCameraFromSourceTile: hostTogglesSpeakerCameraFromSourceTile,
  /**
   * this action tracks the users who toggles speaker source mic from the source tile in order to better understand how often mics are being toggled
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeq6sM9IinTASO0d8uYFaTa9
   * name          : studio host toggles speaker mic from source tile
   * downstreamName: host toggles speaker mic from source tile
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the host hovers over a source on the source tile and toggles mic
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {HostTogglesSpeakerMicFromSourceTile} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  hostTogglesSpeakerMicFromSourceTile: hostTogglesSpeakerMicFromSourceTile,
  /**
   * this action measures the time taken in entering presenter name to display presenter av modal
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeqNEvLvS7ftS2vwD0Iz54Sc
   * name          : studio load presenter av modal
   * downstreamName: load presenter av modal
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when clicking on ask to enter button and ends when presenter av modal gets displayed
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {LoadPresenterAvModal} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  loadPresenterAvModal: loadPresenterAvModal,
  /**
   * this action measures the time taken in director lite application to get loaded till the chime meeting creation
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeny4usepwA0m0rUkS7YjjNP
   * name          : studio meeting as host
   * downstreamName: meeting as host
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the application started for chime meeting creation and ends when the chime meeting got created
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {MeetingAsHost} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  meetingAsHost: meetingAsHost,
  /**
   * this action tracks the users who toggle name cards in order to better understand if and when name cards are used
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMelpdJu18a9oPsUKAdsTMMtT
   * name          : studio name cards toggled
   * downstreamName: name cards toggled
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user toggles the name card
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {NameCardsToggled} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  nameCardsToggled: nameCardsToggled,
  /**
   * this action measures the time taken in presenter getting added to a chime meeting.
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMekRHdCvCEm0GKbgq1JDMFpR
   * name          : studio presenter added to chime meeting
   * downstreamName: presenter added to chime meeting
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when host accepts the knock request and ends when presenter is added to chime meeting successfully
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {PresenterAddedToChimeMeeting} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  presenterAddedToChimeMeeting: presenterAddedToChimeMeeting,
  /**
   * this action measures the time taken in adding/removing the presenter from program
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeqLKQ6UswDojxzDE0hqZ2Je
   * name          : studio presenter program status update
   * downstreamName: presenter program status update
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the host hovers over a presenter source and clicks the show/hide button and ends when presenter is visible/removed from program
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {PresenterProgramStatusUpdate} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  presenterProgramStatusUpdate: presenterProgramStatusUpdate,
  /**
   * this action tracks the users who enter the studio after knock is approved in order to understand speaker experience joining the studio
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMek6vGle76DdjtYLbpUWbh0D
   * name          : studio speaker enters studio
   * downstreamName: speaker enters
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user clicks the enter the studio button on the final join modal
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {SpeakerEnters} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  speakerEnters: speakerEnters,
  /**
   * this action tracks the users who use our stock content for their webinar in order to see how often they are used
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMejtXyCXQZMPvJsQLGazMfSS
   * name          : studio stock content used
   * downstreamName: stock content used
   * owner         : quickfixjedis
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user selects stock content and clicks save button
   * destinations  : Datadog,Mixpanel,Intercom,Snowflake
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StockContentUsed} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  stockContentUsed: stockContentUsed,
  /**
   * this action measures the time taken in starting the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream start lifecycle
   * downstreamName: stream start lifecycle
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the start/startAll stream button and ends when the streaming is started or failed in starting
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStartLifecycle} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStartLifecycle: streamStartLifecycle,
  /**
   * this action measures the time taken in stopping the stream
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            :
   * name          : studio stream stop lifecycle
   * downstreamName: stream stop lifecycle
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       :
   * type          : measure
   * multiStep     :  no
   * trigger       : the measurement starts when the user click on the stop/stopAll stream button and ends when the streaming is stopped or failed in stopping
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {StreamStopLifecycle} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  streamStopLifecycle: streamStopLifecycle,
  /**
   * this action tracks the users who as presenter share screen in order to determine screen share total is working fine
   *
   * Action Definition:
   * ------------------------------------------------------
   * status        : active
   * id            : ev_2VcMeo6kDKYM3TAQr5HBGjykkKw
   * name          : studio total screen share
   * downstreamName: total screen share
   * owner         : qwerty
   * externalName  :
   * release       : v2.0
   * version       : 1-0-0
   * type          : track
   * multiStep     :  no
   * trigger       : this action is triggered when the user shares the screen and see the total count of share screen
   * destinations  : datadog,Mixpanel,Snowflake,Intercom
   * sdk           : analytics.js
   * ------------------------------------------------------
   *
   * @param {TotalScreenShare} [props] - The analytics properties that will be sent to RudderStack.
   * @param {Object} [options] - A dictionary of options. For example, enable or disable specific destinations for the call.
   */
  totalScreenShare: totalScreenShare
};
var _default = exports["default"] = new Proxy(clientAPI, {
  get: function get(target, method) {
    if (typeof method === 'string' && target.hasOwnProperty(method)) {
      return target[method];
    }
    return function () {
      console.warn("\u26A0\uFE0F  You made an analytics call (".concat(String(method), ") that can't be found. Either:\n    a) Re-generate your ruddertyper client: `npx rudder-typer`\n    b) Add it to your Tracking Plan: https://app.rudderstack.com/trackingPlans/tp_2VcMepdGsODn30mzqfuBdd60Wrw"));
      var a = analytics();
      if (a) {
        a.track('Unknown Analytics Call Fired', {
          method: method
        }, withRudderTyperContext());
      }
    };
  }
});